<app-admin-list-page [title]="'Schools' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addSchool()">
    {{'Add' | translate}}
  </button>

  <div slot="filters" class="view-filters card mb-3">

    <div class="card-header d-flex">

      <div class="dropdown flex-grow-1">

        <button class="btn btn-outline-secondary ml-0 mr-2 dropdown-toggle" (click)="filterOpen = !filterOpen">
          {{'Filters' | translate}}
        </button>

        <div id="filterDropdown" [class.d-none]="!filterOpen">

          <div id="view-filter-panels" class="view-filter-panels card-body">

            <div class="row">

              <div class="col-12 col-sm-6">

                <h4>{{'General' | translate}}</h4>

                <div class="form-group">
                  <label>{{ 'Sort on' | translate }}</label>
                  <div class="row">
                    <div class="col-8">
                      <select [(ngModel)]="view.filters.queryParams.SortField" class="form-control">
                        <option value="name">{{ 'Name' | translate }}</option>
                      </select>
                    </div>
                    <div class="col-4">
                      <select [(ngModel)]="view.filters.queryParams.SortType" class="form-control">
                        <option value="Ascending">A-Z</option>
                        <option value="Descending">Z-A</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{'Search' | translate}}</label>
                  <input class="form-control" [(ngModel)]="view.filters.queryParams.SearchTerm" (change)="reloadData()"/>
                </div>

              </div>

            </div>

          </div>

          <div class="d-flex justify-content-between">
            <button class="btn btn-outline-danger ml-0" (click)="resetFilters()">
              {{'Reset filters' | translate}}
            </button>

            <button class="btn btn-outline-primary ml-0" (click)="applyFilters()">
              {{'Apply filters' | translate}}
            </button>
          </div>

        </div>

      </div>

    </div>

  </div>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
